import { render, staticRenderFns } from "./ModalResposta.vue?vue&type=template&id=852703a4"
import script from "./ModalResposta.vue?vue&type=script&lang=js"
export * from "./ModalResposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports